import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { MENU_RENTAL_PORTAL_ITEM } from '../../../constants/menu'
import { ROUTE_PATH_LIST_RENTAL_PORTAL } from '../../../constants/route'
import { usePageBrowserTabTitle } from '../../../hooks'
import Button, { BUTTON_HEIGHT_32 } from '../../Button'
import { Page } from '../../Page'
import { PageHeader } from '../../PageHeader'
import { QA_NAME_RENTAL_PORTAL_PAGE } from '../RentalPortal.constants'

import {
  OVERVIEW_PAYLOAD_FIELD,
  OVERVIEW_PERIOD_DEFAULT,
  QA_NAME_OVERVIEW_SYNC,
} from './RentalPortalOverview.constants'
import { useRentalPortalOverviewRead } from './RentalPortalOverview.hooks'
import { RentalPortalOverviewKpiRow } from './RentalPortalOverviewKpiRow'
import { RentalPortalOverviewLoadError } from './RentalPortalOverviewLoadError'
import { RentalPortalOverviewNoScope } from './RentalPortalOverviewNoScope'
import { RentalPortalOverviewPanels } from './RentalPortalOverviewPanels'
import { RentalPortalOverviewPeriodSelect } from './RentalPortalOverviewPeriodSelect'
import { RentalPortalOverviewRefreshError } from './RentalPortalOverviewRefreshError'

import * as styles from './RentalPortalOverview.module.css'

import RefreshIcon from '../../../icons/refresh.svg'

function RentalPortalOverview() {
  const { t } = useTranslation()

  const [period, setPeriod] = useState(OVERVIEW_PERIOD_DEFAULT)

  const {
    handleReload,
    handleRetry,
    hasBodyError,
    hasNoScope,
    hasStaleError,
    isLoading,
    overview,
  } = useRentalPortalOverviewRead({ period })

  usePageBrowserTabTitle({
    isLoading,
    pageTitle: t('RentalPortal.OverviewTitleKey'),
  })

  function handleSelectPeriod(value) {
    if (value === period) {
      handleReload()
    } else {
      setPeriod(value)
    }
  }

  const breadcrumbs = [
    {
      id: MENU_RENTAL_PORTAL_ITEM.title,
      title: t(MENU_RENTAL_PORTAL_ITEM.title),
      to: `/${ROUTE_PATH_LIST_RENTAL_PORTAL.root}`,
    },
    {
      id: 'RentalPortal.OverviewTitleKey',
      title: t('RentalPortal.OverviewTitleKey'),
    },
  ]

  return (
    <Page qaName={QA_NAME_RENTAL_PORTAL_PAGE}>
      <PageHeader
        breadcrumbs={breadcrumbs}
        title={t('RentalPortal.OverviewTitleKey')}
      />
      <div className={styles.RentalPortalOverview}>
        <div className={styles.header}>
          <RentalPortalOverviewPeriodSelect
            period={overview?.[OVERVIEW_PAYLOAD_FIELD.period]}
            onSelect={handleSelectPeriod}
          />
          <Button.Outlined
            isGrey
            beforeIconProps={{ Icon: RefreshIcon }}
            height={BUTTON_HEIGHT_32}
            isLoading={isLoading}
            qaName={QA_NAME_OVERVIEW_SYNC}
            text={t('RentalPortal.OverviewSyncBtnKey')}
            onClick={handleReload}
          />
        </div>
        {hasBodyError ? (
          <RentalPortalOverviewLoadError onClickRetry={handleRetry} />
        ) : (
          <>
            {hasStaleError ? (
              <RentalPortalOverviewRefreshError onRetry={handleReload} />
            ) : null}
            <RentalPortalOverviewKpiRow
              isLoading={isLoading}
              overview={overview}
            />
            {hasNoScope ? (
              <RentalPortalOverviewNoScope />
            ) : (
              <RentalPortalOverviewPanels
                isLoading={isLoading}
                overview={overview}
                onRetryPanel={handleReload}
              />
            )}
          </>
        )}
      </div>
    </Page>
  )
}

export default RentalPortalOverview
